import { render, staticRenderFns } from "./ClientAssignmentDashboard.vue?vue&type=template&id=776059a6&scoped=true"
import script from "./ClientAssignmentDashboard.vue?vue&type=script&lang=js"
export * from "./ClientAssignmentDashboard.vue?vue&type=script&lang=js"
import style0 from "./ClientAssignmentDashboard.vue?vue&type=style&index=0&id=776059a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776059a6",
  null
  
)

export default component.exports